<app-menu>
  <div class="loading-overlay" *ngIf="isLoading">
    <div class="loading-content">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <p>Loading, please wait...</p>
    </div>
  </div>

  <div class="min-h-screen bg-[linear-gradient(180deg,#f8fafc_0%,#eef2ff_55%,#f8fafc_100%)]">
    <div class="mx-auto flex w-full max-w-[1800px] flex-col gap-4 px-4 py-4 md:px-6 xl:px-8">
      <section class="wo-hero overflow-hidden rounded-[20px] border border-slate-200/80 bg-slate-950 text-white shadow-[0_20px_45px_-30px_rgba(15,23,42,0.68)]">
        <div class="wo-hero__content px-4 py-4 md:px-5">
          <div class="wo-hero__top">
            <div class="wo-hero__primary">
              <div class="wo-hero__eyebrow-row">
                <span class="wo-hero__badge wo-hero__badge--eyebrow">Work Order Details</span>
                <span class="wo-hero__kicker">Reference</span>
              </div>
              <h1 class="wo-hero__reference">{{ generalInfoForm.get('alternateReference')?.value || generalInfoForm.get('ladingNumber')?.value || 'No Ref' }}</h1>
              <div class="wo-hero__identity-row">
                <div class="wo-hero__uuid-row">
                  <span class="wo-hero__uuid-icon">
                    <i class="fas fa-link"></i>
                  </span>
                  <span class="wo-hero__uuid">{{ generalInfoForm.get('ladingUuid')?.value || 'N/A' }}</span>
                </div>
                <span class="wo-hero__identity-separator" aria-hidden="true"></span>
                <p class="wo-hero__customer">{{ generalInfoForm.get('customerName')?.value || 'Customer Unassigned' }}</p>
              </div>
            </div>

            <div class="wo-hero__side">
              <div class="wo-hero__side-main">
                <div class="wo-hero__status-card">
                  <span class="wo-hero__status-dot"></span>
                  <span class="wo-hero__status-text">{{ generalInfoForm.get('ladingStatus')?.value || 'Pending' }}</span>
                </div>

                <div class="wo-hero__pill-row">
                  <span class="wo-hero__pill">
                    <span class="wo-hero__pill-label">Pro Bill</span>
                    <span class="wo-hero__pill-value">{{ generalInfoForm.get('proBill')?.value || 'N/A' }}</span>
                  </span>
                  <span class="wo-hero__pill">
                    <span class="wo-hero__pill-label">Equipment</span>
                    <span class="wo-hero__pill-value">{{ generalInfoForm.get('typeOfEquipment')?.value || 'Standard' }}</span>
                  </span>
                </div>
              </div>

              <p class="wo-hero__touched">
                Last Modified:
                <span>{{ generalInfoForm.get('modifiedDate')?.value || generalInfoForm.get('created')?.value || 'N/A' }}</span>
              </p>
            </div>
          </div>

          <div class="wo-hero__metrics">
            <div class="wo-hero__metric wo-hero__metric--blue">
              <span class="wo-hero__metric-label">Appointment Window</span>
              <div class="wo-hero__metric-detail">
                <p class="wo-hero__metric-value">{{ generalInfoForm.get('appointmentDate')?.value || 'N/A' }}</p>
                <p class="wo-hero__metric-sub">
                  <span>{{ generalInfoForm.get('appointmentStart')?.value || 'No time set' }}</span>
                  <ng-container *ngIf="generalInfoForm.get('appointmentEnd')?.value"> - {{ generalInfoForm.get('appointmentEnd')?.value }}</ng-container>
                </p>
              </div>
            </div>

            <div class="wo-hero__metric wo-hero__metric--indigo">
              <span class="wo-hero__metric-label">Pick-up</span>
              <div class="wo-hero__metric-detail">
                <p class="wo-hero__metric-value">{{ generalInfoForm.get('loadStartDate')?.value || 'N/A' }}</p>
                <p class="wo-hero__metric-sub">{{ generalInfoForm.get('loadStartTime')?.value || 'No time set' }}</p>
              </div>
            </div>

            <div class="wo-hero__metric wo-hero__metric--violet">
              <span class="wo-hero__metric-label">Delivery</span>
              <div class="wo-hero__metric-detail">
                <p class="wo-hero__metric-value">{{ generalInfoForm.get('loadEndDate')?.value || 'N/A' }}</p>
                <p class="wo-hero__metric-sub">{{ generalInfoForm.get('loadEndTime')?.value || 'No time set' }}</p>
              </div>
            </div>

            <div class="wo-hero__metric wo-hero__metric--emerald">
              <span class="wo-hero__metric-label">Load Metrics</span>
              <div class="wo-hero__metric-detail">
                <p class="wo-hero__metric-value">
                  {{ generalInfoForm.get('loadWeightActual')?.value || generalInfoForm.get('loadWeight')?.value || '0' }}
                  <span class="uppercase">{{ generalInfoForm.get('loadWeightUnit')?.value || 'lb' }}</span>
                </p>
                <p class="wo-hero__metric-sub">
                  Pcs: {{ generalInfoForm.get('loadPieces')?.value || '0' }}
                  &bull;
                  Pal: {{ generalInfoForm.get('loadPallets')?.value || '0' }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <app-work-order-pickups *ngIf="canViewWorkOrderHistory" [ladingUuid]="workOrderLadingUuid"></app-work-order-pickups>

      <mat-tab-group class="work-order-tab-shell overflow-hidden rounded-[32px] border border-slate-200/80 bg-white/85 shadow-[0_30px_70px_-40px_rgba(15,23,42,0.45)] backdrop-blur" [selectedIndex]="selectedWorkOrderTabIndex" (selectedTabChange)="onTabChange($event)">
    
        <mat-tab label="General Info">
          <div class="p-4 pb-28 md:p-6 md:pb-32 xl:p-8 xl:pb-32">
            <form [formGroup]="generalInfoForm">
              <mat-card class="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-none">
                <mat-card-header class="border-b border-slate-200 bg-slate-50/80 px-6 py-4">
                  <mat-card-title class="flex items-center gap-3 text-2xl font-semibold tracking-tight text-slate-900">
                    <span class="flex h-10 w-10 items-center justify-center rounded-2xl bg-sky-500/10 text-sky-700">
                      <i class="fas fa-info-circle"></i>
                    </span>
                    <span>General Information</span>
                  </mat-card-title>
                </mat-card-header>

                <mat-card-content class="space-y-4 px-6 py-6">

              <section class="wo-detail-section">
                <div class="wo-detail-section__intro">
                  <h3 class="wo-detail-section__title">Identifiers & Status</h3>
                </div>
                <div class="wo-detail-section__panel">
                  <div class="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-12">
                    <div *ngIf="alternate_reference" class="xl:col-span-4">
                      <div class="wo-inline-field">
                        <label class="wo-inline-label" for="alternateReference">Alternate Reference</label>
                        <input id="alternateReference" class="wo-inline-control" formControlName="alternateReference" />
                      </div>
                    </div>
                    <div *ngIf="!alternate_reference" class="xl:col-span-4">
                      <button type="button" class="wo-inline-action" (click)="qualifyOrder()" [disabled]="qualificationInProgress" [attr.aria-busy]="qualificationInProgress">
                        {{ qualificationInProgress ? 'Qualifying…' : 'Qualify Order' }}
                      </button>
                      <p *ngIf="qualificationMessage" class="mt-2 text-sm text-slate-600" role="status">{{ qualificationMessage }}</p>
                    </div>
                    <div class="xl:col-span-4">
                      <div class="wo-inline-field">
                        <label class="wo-inline-label" for="ladingStatus">Lading Status</label>
                        <select id="ladingStatus" class="wo-inline-control wo-inline-control--select" formControlName="ladingStatus">
                          <option *ngFor="let status of ladingStatuses" [value]="status">{{ status }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="xl:col-span-2">
                      <div class="wo-inline-field">
                        <label class="wo-inline-label" for="ladingNumber">Lading Number</label>
                        <input id="ladingNumber" class="wo-inline-control" formControlName="ladingNumber" />
                      </div>
                    </div>
                    <div class="xl:col-span-2">
                      <div class="wo-inline-field">
                        <label class="wo-inline-label" for="proBill">Pro Bill</label>
                        <input id="proBill" class="wo-inline-control" formControlName="proBill" />
                      </div>
                    </div>
                    <div class="xl:col-span-3">
                      <div class="wo-inline-field">
                        <label class="wo-inline-label" for="tripNumber">Trip Number</label>
                        <input id="tripNumber" class="wo-inline-control" formControlName="tripNumber" />
                      </div>
                    </div>
                    <div class="xl:col-span-3">
                      <div class="wo-inline-field">
                        <label class="wo-inline-label" for="dropTrailerStatus">Drop Trailer Status</label>
                        <select id="dropTrailerStatus" class="wo-inline-control wo-inline-control--select" formControlName="dropTrailerStatus">
                          <option value="">Select status</option>
                          <option *ngFor="let status of dropTrailerStatuses" [value]="status">{{ status }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="xl:col-span-6">
                      <div class="wo-inline-field">
                        <label class="wo-inline-label" for="weekNo">Week No.</label>
                        <input id="weekNo" class="wo-inline-control" formControlName="weekNo" />
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section class="wo-detail-section">
                <div class="wo-detail-section__intro">
                  <h3 class="wo-detail-section__title">Processing Flags</h3>
                </div>
                <div class="wo-detail-section__panel">
                  <div class="flex flex-wrap gap-3">
                    <label class="wo-flag-pill">
                      <input type="checkbox" class="peer sr-only" formControlName="hot" />
                      <span>Hot</span>
                    </label>
                    <label class="wo-flag-pill">
                      <input type="checkbox" class="peer sr-only" formControlName="expedited" />
                      <span>Expedited</span>
                    </label>
                    <label class="wo-flag-pill">
                      <input type="checkbox" class="peer sr-only" formControlName="dropTrailer" />
                      <span>Drop Trailer</span>
                    </label>
                  </div>
                </div>
              </section>

              <section class="wo-detail-section">
                <div class="wo-detail-section__intro">
                  <h3 class="wo-detail-section__title">Routing Parties</h3>
                </div>
                <div class="wo-detail-section__panel">
                  <div class="grid grid-cols-1 gap-3 md:grid-cols-2">
                    <div class="wo-entity-card">
                      <span class="wo-entity-card__icon"><i class="fas fa-briefcase"></i></span>
                      <div class="wo-entity-card__body">
                        <span class="wo-summary-label">Customer</span>
                        <p class="wo-summary-value">{{ generalInfoForm.get('customerName')?.value || 'N/A' }}</p>
                      </div>
                    </div>
                    <div class="wo-entity-card">
                      <span class="wo-entity-card__icon"><i class="fas fa-truck"></i></span>
                      <div class="wo-entity-card__body">
                        <span class="wo-summary-label">Carrier</span>
                        <p class="wo-summary-value">{{ generalInfoForm.get('carrierName')?.value || 'N/A' }}</p>
                      </div>
                    </div>
                    <div class="wo-entity-card">
                      <span class="wo-entity-card__icon"><i class="fas fa-warehouse"></i></span>
                      <div class="wo-entity-card__body">
                        <span class="wo-summary-label">Shipper</span>
                        <p class="wo-summary-value">{{ generalInfoForm.get('shipperName')?.value || 'N/A' }}</p>
                      </div>
                    </div>
                    <div class="wo-entity-card">
                      <span class="wo-entity-card__icon"><i class="fas fa-map-marker-alt"></i></span>
                      <div class="wo-entity-card__body">
                        <span class="wo-summary-label">Consignee</span>
                        <p class="wo-summary-value">{{ generalInfoForm.get('consigneeName')?.value || 'N/A' }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section class="wo-detail-section">
                <div class="wo-detail-section__intro">
                  <h3 class="wo-detail-section__title">Shipment Details</h3>
                </div>
                <div class="wo-detail-section__panel">
                  <div class="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-12">
                    <div class="xl:col-span-3">
                      <div class="wo-inline-field">
                        <label class="wo-inline-label" for="partialOrFull">Partial or Full</label>
                        <input id="partialOrFull" class="wo-inline-control" formControlName="partialOrFull" />
                      </div>
                    </div>
                    <div class="xl:col-span-2">
                      <div class="wo-inline-field">
                        <label class="wo-inline-label" for="ladingId">Lading ID</label>
                        <input id="ladingId" class="wo-inline-control" formControlName="ladingId" />
                      </div>
                    </div>
                    <div class="xl:col-span-2">
                      <div class="wo-inline-field">
                        <label class="wo-inline-label" for="shipmentNumber">Shipment Number</label>
                        <input id="shipmentNumber" class="wo-inline-control" formControlName="shipmentNumber" />
                      </div>
                    </div>
                    <div class="xl:col-span-5">
                      <div class="wo-inline-field">
                        <label class="wo-inline-label" for="carrierTrailer">Carrier Trailer</label>
                        <input id="carrierTrailer" class="wo-inline-control" formControlName="carrierTrailer" />
                      </div>
                    </div>
                    <div class="xl:col-span-6">
                      <div class="wo-inline-field">
                        <label class="wo-inline-label" for="customerPo">Customer PO</label>
                        <input id="customerPo" class="wo-inline-control" formControlName="customerPo" />
                      </div>
                    </div>
                    <div class="xl:col-span-6">
                      <div class="wo-inline-field">
                        <label class="wo-inline-label" for="thirdPartyTrackingUrl">Third Party Tracking URL</label>
                        <div class="flex items-center gap-2">
                          <input
                            id="thirdPartyTrackingUrl"
                            class="wo-inline-control min-w-0"
                            type="url"
                            formControlName="thirdPartyTrackingUrl"
                          />
                          <a
                            *ngIf="getThirdPartyTrackingUrl() as trackingUrl"
                            class="inline-flex h-8 shrink-0 items-center justify-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 text-xs font-semibold text-slate-700 transition hover:border-slate-300 hover:bg-slate-100"
                            [href]="trackingUrl"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Open third-party tracking URL"
                          >
                            <i class="fas fa-external-link-alt text-xs"></i>
                            <span>Open</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section class="wo-detail-section">
                <div class="wo-detail-section__intro">
                  <h3 class="wo-detail-section__title">Weights & Dimensions</h3>
                </div>
                <div class="wo-detail-section__panel">
                  <div class="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-12">
                    <div class="xl:col-span-3">
                      <div class="grid grid-cols-[minmax(0,1fr)_5.5rem] gap-2">
                        <div class="wo-inline-field">
                          <label class="wo-inline-label" for="loadWeight">Load Weight</label>
                          <input id="loadWeight" class="wo-inline-control" type="number" formControlName="loadWeight" />
                        </div>
                        <div class="wo-inline-field">
                          <label class="wo-inline-label" for="loadWeightUnit">Unit</label>
                          <select id="loadWeightUnit" class="wo-inline-control wo-inline-control--select wo-unit-select" formControlName="loadWeightUnit">
                            <option value="">Unit</option>
                            <option *ngFor="let unit of weightUnits" [value]="unit.value">{{ unit.label }}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="xl:col-span-3">
                      <div class="wo-inline-field">
                        <label class="wo-inline-label" for="loadWeightActual">Actual Weight</label>
                        <input id="loadWeightActual" class="wo-inline-control" type="number" formControlName="loadWeightActual" />
                      </div>
                    </div>
                    <div class="xl:col-span-3">
                      <div class="grid grid-cols-[minmax(0,1fr)_5.5rem] gap-2">
                        <div class="wo-inline-field">
                          <label class="wo-inline-label" for="loadLength">Load Length</label>
                          <input id="loadLength" class="wo-inline-control" type="number" formControlName="loadLength" />
                        </div>
                        <div class="wo-inline-field">
                          <label class="wo-inline-label" for="loadLengthUnit">Unit</label>
                          <select id="loadLengthUnit" class="wo-inline-control wo-inline-control--select wo-unit-select" formControlName="loadLengthUnit">
                            <option value="">Unit</option>
                            <option *ngFor="let unit of lengthUnits" [value]="unit.value">{{ unit.label }}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="xl:col-span-3">
                      <div class="wo-inline-field">
                        <label class="wo-inline-label" for="loadPallets">Pallets</label>
                        <input id="loadPallets" class="wo-inline-control" type="number" formControlName="loadPallets" />
                      </div>
                    </div>
                    <div class="xl:col-span-3">
                      <div class="wo-inline-field">
                        <label class="wo-inline-label" for="loadPieces">Pieces</label>
                        <input id="loadPieces" class="wo-inline-control" type="number" formControlName="loadPieces" />
                      </div>
                    </div>
                    <div class="xl:col-span-9">
                      <div class="wo-inline-field">
                        <label class="wo-inline-label" for="typeOfEquipment">Type of Equipment</label>
                        <select id="typeOfEquipment" class="wo-inline-control wo-inline-control--select" formControlName="typeOfEquipment">
                          <option value="">Select equipment</option>
                          <option *ngFor="let eq of equipmentTypes" [value]="eq.code">{{ eq.name }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section class="wo-detail-section">
                <div class="wo-detail-section__intro">
                  <h3 class="wo-detail-section__title">Scheduling</h3>
                </div>
                <div class="wo-detail-section__panel">
                  <div class="grid gap-3 xl:grid-cols-2">
                    <div class="wo-schedule-card wo-schedule-card--blue">
                      <div class="wo-schedule-card__head">
                        <h4 class="wo-schedule-card__title">Appointment & Pick-up</h4>
                        <span class="wo-schedule-card__badge">{{ generalInfoForm.get('appointmentTimezone')?.value || 'Timezone' }}</span>
                      </div>
                      <div class="grid grid-cols-1 gap-3 md:grid-cols-2">
                        <div class="wo-inline-field">
                          <label class="wo-inline-label" for="appointmentDate">Appointment Date</label>
                          <input id="appointmentDate" class="wo-inline-control" type="date" formControlName="appointmentDate" />
                        </div>
                        <div class="wo-inline-field">
                          <label class="wo-inline-label" for="appointmentTimezone">Timezone</label>
                          <select id="appointmentTimezone" class="wo-inline-control wo-inline-control--select" formControlName="appointmentTimezone">
                            <option *ngFor="let tz of timezones" [value]="tz">{{ tz }}</option>
                          </select>
                        </div>
                        <div class="wo-inline-field">
                          <label class="wo-inline-label" for="appointmentStart">Appointment Start</label>
                          <input id="appointmentStart" class="wo-inline-control" type="time" formControlName="appointmentStart" />
                        </div>
                        <div class="wo-inline-field">
                          <label class="wo-inline-label" for="appointmentEnd">Appointment End</label>
                          <input id="appointmentEnd" class="wo-inline-control" type="time" formControlName="appointmentEnd" />
                        </div>
                        <div class="wo-inline-field">
                          <label class="wo-inline-label" for="loadStartDate">Pick-up Date</label>
                          <input id="loadStartDate" class="wo-inline-control" type="date" formControlName="loadStartDate" />
                        </div>
                        <div class="wo-inline-field">
                          <label class="wo-inline-label" for="loadStartTime">Pick-up Time</label>
                          <input id="loadStartTime" class="wo-inline-control" type="time" formControlName="loadStartTime" />
                        </div>
                      </div>
                      <p class="wo-inline-helper mt-3">
                        Estimated pick-up: {{ generalInfoForm.get('estimatedLoadStart')?.value || 'N/A' }}
                        <span *ngIf="generalInfoForm.get('estimatedLoadStartHours')?.value"> · {{ generalInfoForm.get('estimatedLoadStartHours')?.value }}</span>
                      </p>
                    </div>

                    <div class="wo-schedule-card wo-schedule-card--violet">
                      <div class="wo-schedule-card__head">
                        <h4 class="wo-schedule-card__title">Delivery</h4>
                        <span class="wo-schedule-card__badge">{{ generalInfoForm.get('appointmentTimezone')?.value || 'Timezone' }}</span>
                      </div>
                      <div class="grid grid-cols-1 gap-3 md:grid-cols-2">
                        <div class="wo-inline-field">
                          <label class="wo-inline-label" for="loadEndDate">Delivery Date</label>
                          <input id="loadEndDate" class="wo-inline-control" type="date" formControlName="loadEndDate" />
                        </div>
                        <div class="wo-inline-field">
                          <label class="wo-inline-label" for="loadEndTime">Delivery Time</label>
                          <input id="loadEndTime" class="wo-inline-control" type="time" formControlName="loadEndTime" />
                        </div>
                      </div>
                      <p class="wo-inline-helper mt-3">
                        Estimated delivery: {{ generalInfoForm.get('estimatedLoadEnd')?.value || 'N/A' }}
                        <span *ngIf="generalInfoForm.get('estimatedLoadEndHours')?.value"> · {{ generalInfoForm.get('estimatedLoadEndHours')?.value }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </section>

              <section class="wo-detail-section">
                <div class="wo-detail-section__intro">
                  <h3 class="wo-detail-section__title">Special Info & Audit</h3>
                </div>
                <div class="wo-detail-section__panel">
                  <div class="grid grid-cols-1 gap-3 xl:grid-cols-[minmax(0,1.4fr)_minmax(320px,0.8fr)]">
                    <div class="wo-inline-field wo-inline-field--textarea">
                      <label class="wo-inline-label" for="loadSpecialInfo">Load Special Info</label>
                      <textarea id="loadSpecialInfo" class="wo-inline-control wo-inline-control--textarea" formControlName="loadSpecialInfo" rows="5"></textarea>
                    </div>
                    <div class="grid grid-cols-1 gap-3 md:grid-cols-3 xl:grid-cols-1">
                      <div class="wo-info-tile">
                        <span class="wo-summary-label">Created</span>
                        <p class="wo-summary-value">{{ generalInfoForm.get('created')?.value || 'N/A' }}</p>
                      </div>
                      <div class="wo-info-tile">
                        <span class="wo-summary-label">Last Modified Date</span>
                        <p class="wo-summary-value">{{ generalInfoForm.get('modifiedDate')?.value || 'N/A' }}</p>
                      </div>
                      <div class="wo-info-tile">
                        <span class="wo-summary-label">Last Modified Time</span>
                        <p class="wo-summary-value">{{ generalInfoForm.get('modifiedTime')?.value || 'N/A' }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
                </mat-card-content>
              </mat-card>
            </form>

          </div>
        </mat-tab>

        <mat-tab label="Notes">
          <div class="p-4 md:p-6 xl:p-8">
            <mat-card class="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-none">
              <mat-card-header class="border-b border-slate-200 bg-slate-50/80 px-6 py-4">
                <mat-card-title class="flex items-center gap-3 text-2xl font-semibold tracking-tight text-slate-900">
                  <span class="flex h-10 w-10 items-center justify-center rounded-2xl bg-indigo-500/10 text-indigo-700">
                    <i class="fas fa-comments"></i>
                  </span>
                  <span>Notes</span>
                </mat-card-title>
              </mat-card-header>

              <mat-card-content class="space-y-5 px-6 py-6">
                <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                  <p class="text-sm font-medium text-slate-500">
                    {{ ladingNotes.length }} {{ ladingNotes.length === 1 ? 'entry' : 'entries' }}
                  </p>
                  <div class="flex flex-wrap gap-2">
                    <button type="button" class="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition hover:border-slate-300 hover:bg-slate-50" (click)="addNote()">
                      <i class="fas fa-plus"></i>
                      <span>Add Note</span>
                    </button>
                    <button type="button" class="inline-flex items-center gap-2 rounded-full bg-slate-900 px-4 py-2 text-sm font-semibold text-white transition hover:bg-slate-800" (click)="saveNotes()">
                      <i class="fas fa-save"></i>
                      <span>Save Notes</span>
                    </button>
                  </div>
                </div>

                <div class="mx-auto max-w-[1120px] space-y-4">
                <div *ngIf="ladingNotes.length === 0" class="rounded-2xl border border-dashed border-slate-300 bg-slate-50 px-5 py-8 text-center text-sm text-slate-500">
                  No notes yet.
                </div>

                <article *ngFor="let note of ladingNotes; let i = index" class="wo-note-card">
                  <div class="wo-note-card__header">
                    <div class="min-w-0 space-y-1">
                      <div class="flex flex-wrap items-center gap-2">
                        <span class="wo-note-card__author">{{ note.created_by || note.modified_by || 'Unassigned' }}</span>
                        <span class="wo-note-card__badge">{{ note.lading_note_uuid ? 'Saved' : 'New' }}</span>
                      </div>
                      <div class="wo-note-card__stamp">
                        <span *ngIf="note.date">Created {{ note.date | date:'MMM d, y, h:mm a' }}</span>
                        <span *ngIf="note.modified_by && note.date_last_modified">
                          <ng-container *ngIf="note.date">·</ng-container>
                          Updated {{ note.date_last_modified | date:'MMM d, y, h:mm a' }}
                        </span>
                      </div>
                    </div>
                    <div class="wo-note-card__actions">
                      <label class="wo-note-card__audience">
                        <span>For</span>
                        <select [(ngModel)]="note.contact_uuid" [ngModelOptions]="{standalone: true}" class="wo-note-card__audience-select">
                          <option *ngFor="let option of noteAudienceOptions" [value]="option.value">{{ option.label }}</option>
                        </select>
                      </label>
                      <button type="button" class="wo-note-card__delete" (click)="deleteNote(i)">
                        <i class="fas fa-trash"></i>
                        <span>Delete</span>
                      </button>
                    </div>
                  </div>

                  <div class="flex flex-col gap-3">
                    <textarea
                      #noteTextarea
                      [(ngModel)]="note.note"
                      [ngModelOptions]="{standalone: true}"
                      placeholder="Add note..."
                      rows="4"
                      class="wo-textarea wo-note-card__textarea"
                    ></textarea>

                    <div class="wo-note-card__footer">
                      <span class="wo-note-card__index">Note {{ i + 1 }}</span>
                    </div>
                  </div>
                </article>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-tab>
      
        <mat-tab label="Status">
          <div class="grid gap-4 p-3 md:p-4 xl:grid-cols-[minmax(0,1.55fr)_minmax(18rem,0.75fr)] xl:p-5">
            <section class="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
              <div class="flex flex-col gap-2 border-b border-slate-200 bg-slate-50/80 px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
                <div class="flex items-center gap-2.5">
                  <span class="flex h-8 w-8 items-center justify-center rounded-xl bg-sky-500/10 text-sm text-sky-700">
                    <i class="fas fa-route"></i>
                  </span>
                  <div>
                    <h2 class="text-lg font-semibold tracking-tight text-slate-900">Status timeline</h2>
                    <p class="m-0 text-xs text-slate-500">Recorded timestamps are server-owned and read-only.</p>
                  </div>
                </div>
                <button type="button" class="inline-flex h-9 items-center justify-center gap-2 rounded-lg bg-slate-900 px-3.5 text-sm font-semibold text-white transition hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-50" (click)="addNewStatus()" [disabled]="statusSaveInProgress">
                  <i class="fas fa-plus"></i>
                  <span>Add Status</span>
                </button>
              </div>

              <div class="relative space-y-3 px-3 py-4 sm:px-4">
                <div *ngIf="statusForms.length > 0" class="absolute bottom-8 left-[1.65rem] top-8 w-px bg-slate-200 sm:left-[2.15rem]"></div>

                <div *ngIf="statusForms.length === 0" class="rounded-xl border border-dashed border-slate-300 bg-slate-50 px-4 py-6 text-center text-sm text-slate-500">
                  No status events recorded.
                </div>

                <form *ngFor="let statusForm of statusForms; let i = index" [formGroup]="statusForm" class="relative pl-8 sm:pl-10">
                  <span class="absolute left-[0.7rem] top-4 z-[1] h-3 w-3 rounded-full border-[3px] border-white shadow-sm sm:left-[0.7rem]"
                        [class.bg-emerald-500]="isCurrentStatus(statusForm)"
                        [class.bg-sky-500]="!statusForm.get('timelineUuid')?.value"
                        [class.bg-slate-400]="statusForm.get('timelineUuid')?.value && !isCurrentStatus(statusForm)"></span>

                  <div class="rounded-xl border bg-white p-3 transition"
                       [class.border-emerald-200]="isCurrentStatus(statusForm)"
                       [class.ring-1]="isCurrentStatus(statusForm)"
                       [class.ring-emerald-100]="isCurrentStatus(statusForm)"
                       [class.border-sky-200]="!statusForm.get('timelineUuid')?.value"
                       [class.border-slate-200]="statusForm.get('timelineUuid')?.value && !isCurrentStatus(statusForm)">
                    <div class="mb-3 flex flex-col gap-2 lg:flex-row lg:items-center lg:justify-between">
                      <div class="flex min-w-0 flex-wrap items-center gap-2">
                        <span *ngIf="isCurrentStatus(statusForm)" class="rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.14em] text-emerald-700">Current</span>
                        <span *ngIf="!statusForm.get('timelineUuid')?.value" class="rounded-full bg-sky-50 px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.14em] text-sky-700">New</span>
                        <span *ngIf="statusForm.get('timelineUuid')?.value && !isCurrentStatus(statusForm)" class="rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.14em] text-slate-600">History</span>
                        <span class="truncate text-sm font-semibold text-slate-800">{{ statusForm.get('status')?.value || 'Select a status' }}</span>
                        <span class="hidden text-xs text-slate-400 sm:inline">{{ formatStatusEventAt(statusForm) }}</span>
                      </div>

                      <div class="flex shrink-0 items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-2.5 py-1.5" title="Set automatically by the server; it cannot be edited.">
                        <i class="fas fa-lock text-[10px] text-slate-400"></i>
                        <div class="leading-tight">
                          <div class="text-[9px] font-bold uppercase tracking-[0.13em] text-slate-400">Recorded at</div>
                          <div class="text-xs font-semibold text-slate-600">{{ formatStatusRecordedAt(statusForm) }}</div>
                        </div>
                      </div>
                    </div>

                    <div class="grid grid-cols-1 gap-2 sm:grid-cols-2 xl:grid-cols-12">
                      <div class="xl:col-span-3">
                        <label class="mb-1 block text-[10px] font-bold uppercase tracking-[0.12em] text-slate-500">Status</label>
                        <select class="h-9 w-full rounded-lg border border-slate-300 bg-white px-2.5 text-sm text-slate-800 outline-none transition focus:border-sky-500 focus:ring-2 focus:ring-sky-100" formControlName="status">
                          <option value="">Select status</option>
                          <option *ngFor="let status of ladingStatuses" [value]="status">{{ status }}</option>
                        </select>
                      </div>

                      <div class="xl:col-span-2">
                        <label class="mb-1 block text-[10px] font-bold uppercase tracking-[0.12em] text-slate-500">Event date</label>
                        <input class="h-9 w-full rounded-lg border border-slate-300 bg-white px-2.5 text-sm text-slate-800 outline-none transition focus:border-sky-500 focus:ring-2 focus:ring-sky-100" type="date" formControlName="eventDate" />
                      </div>
                      <div class="xl:col-span-2">
                        <label class="mb-1 block text-[10px] font-bold uppercase tracking-[0.12em] text-slate-500">Event time</label>
                        <input class="h-9 w-full rounded-lg border border-slate-300 bg-white px-2.5 text-sm text-slate-800 outline-none transition focus:border-sky-500 focus:ring-2 focus:ring-sky-100" type="time" formControlName="eventTime" />
                      </div>
                      <div class="xl:col-span-5">
                        <label class="mb-1 block text-[10px] font-bold uppercase tracking-[0.12em] text-slate-500">Event timezone</label>
                        <select class="h-9 w-full rounded-lg border border-slate-300 bg-white px-2.5 text-sm text-slate-800 outline-none transition focus:border-sky-500 focus:ring-2 focus:ring-sky-100" formControlName="eventTimeZone">
                          <option *ngFor="let timezone of timezones" [value]="timezone">{{ timezone }}</option>
                        </select>
                      </div>

                      <div class="sm:col-span-2 xl:col-span-12 rounded-lg border border-sky-100 bg-sky-50/60 p-2.5">
                        <div class="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
                          <div class="grid flex-1 grid-cols-1 gap-2 sm:grid-cols-2 lg:max-w-lg">
                            <div>
                              <label class="mb-1 block text-[10px] font-bold uppercase tracking-[0.12em] text-sky-700">Consignee local date</label>
                              <input class="h-9 w-full rounded-lg border border-sky-200 bg-white px-2.5 text-sm text-slate-700 outline-none transition disabled:cursor-not-allowed disabled:bg-sky-50 disabled:text-slate-600" type="date" formControlName="dateLocal" />
                            </div>
                            <div>
                              <label class="mb-1 block text-[10px] font-bold uppercase tracking-[0.12em] text-sky-700">Consignee local time</label>
                              <input class="h-9 w-full rounded-lg border border-sky-200 bg-white px-2.5 text-sm text-slate-700 outline-none transition disabled:cursor-not-allowed disabled:bg-sky-50 disabled:text-slate-600" type="time" formControlName="timeLocal" />
                            </div>
                          </div>

                          <div class="flex items-center justify-between gap-3 sm:justify-end">
                            <div class="text-right leading-tight">
                              <div class="text-[9px] font-bold uppercase tracking-[0.12em] text-sky-600">Consignee timezone</div>
                              <div class="text-xs font-semibold text-slate-700">{{ statusForm.get('localTimeZone')?.value }}</div>
                            </div>
                            <button type="button" class="inline-flex h-9 items-center justify-center gap-1.5 rounded-lg border border-sky-200 bg-white px-3 text-xs font-semibold text-sky-700 transition hover:bg-sky-50" (click)="toggleLocalTimeOverride(statusForm)" [disabled]="statusSaveInProgress">
                              <i class="fas" [class.fa-pen]="!statusForm.get('localOverride')?.value" [class.fa-undo]="statusForm.get('localOverride')?.value"></i>
                              <span>{{ statusForm.get('localOverride')?.value ? 'Use automatic' : 'Override local time' }}</span>
                            </button>
                          </div>
                        </div>
                        <p class="mt-1.5 text-[10px] leading-4" [class.text-amber-700]="statusForm.get('localOverride')?.value" [class.text-sky-700]="!statusForm.get('localOverride')?.value">
                          {{ statusForm.get('localOverride')?.value
                            ? 'Manual override: only the consignee-local timestamp will change; the submitted event time remains unchanged.'
                            : 'Calculated by the backend from the submitted event time and the consignee address timezone.' }}
                        </p>
                      </div>

                      <div class="sm:col-span-2 xl:col-span-9">
                        <label class="mb-1 block text-[10px] font-bold uppercase tracking-[0.12em] text-slate-500">Status note</label>
                        <textarea class="min-h-9 w-full resize-y rounded-lg border border-slate-300 bg-white px-2.5 py-2 text-sm leading-5 text-slate-800 outline-none transition placeholder:text-slate-400 focus:border-sky-500 focus:ring-2 focus:ring-sky-100" rows="1" formControlName="note" placeholder="Optional note"></textarea>
                      </div>

                      <div class="flex items-end justify-end gap-1.5 sm:col-span-2 xl:col-span-3">
                        <button *ngIf="statusForm.dirty || !statusForm.get('timelineUuid')?.value" type="button" class="inline-flex h-9 items-center justify-center gap-1.5 rounded-lg border border-slate-200 bg-white px-2.5 text-xs font-semibold text-slate-600 transition hover:bg-slate-50 disabled:opacity-50" (click)="cancelStatusChange(i)" [disabled]="statusSaveInProgress">
                          <i class="fas fa-times"></i>
                          <span>Cancel</span>
                        </button>
                        <button type="button" class="inline-flex h-9 items-center justify-center gap-1.5 rounded-lg bg-slate-900 px-3 text-xs font-semibold text-white transition hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-50" (click)="submitStatus(i)" [disabled]="statusSaveInProgress || statusForm.pristine">
                          <i class="fas fa-save"></i>
                          <span>Save</span>
                        </button>
                        <button *ngIf="statusForm.get('timelineUuid')?.value" type="button" class="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-rose-200 bg-white text-xs text-rose-600 transition hover:bg-rose-50 disabled:cursor-not-allowed disabled:border-slate-200 disabled:text-slate-300" (click)="deleteStatus(i)" [disabled]="statusSaveInProgress || isCurrentStatus(statusForm)" [title]="isCurrentStatus(statusForm) ? 'Add a replacement status before deleting the current event.' : 'Delete historical event'">
                          <i class="fas fa-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </section>

            <section class="self-start overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm xl:sticky xl:top-4">
              <div class="flex items-center gap-2.5 border-b border-slate-200 bg-slate-50/80 px-4 py-3">
                <span class="flex h-8 w-8 items-center justify-center rounded-xl bg-indigo-500/10 text-sm text-indigo-700">
                  <i class="fas fa-map-marked-alt"></i>
                </span>
                <h2 class="text-lg font-semibold tracking-tight text-slate-900">Route map</h2>
              </div>

              <div class="p-3">
                <div *ngIf="!statusMapLoaded" class="flex min-h-80 items-center justify-center rounded-xl border border-dashed border-slate-300 bg-slate-50 px-4 text-sm text-slate-500">
                  Loading map data...
                </div>

                <div *ngIf="statusMapLoaded && statusMapPoints.length === 0" class="flex min-h-80 items-center justify-center rounded-xl border border-dashed border-slate-300 bg-slate-50 px-4 text-center text-sm text-slate-500">
                  No mappable status coordinates available.
                </div>

                <div #statusMapContainer class="status-map" [class.hidden]="!statusMapLoaded || statusMapPoints.length === 0"></div>
              </div>
            </section>
          </div>
        </mat-tab>
        
        <mat-tab label="Freight">
          <div class="p-4 md:p-6 xl:p-8">
            <app-freight></app-freight>
          </div>
        </mat-tab>

        <mat-tab label="Customer Info">
          <section *ngIf="billing?.accounts?.length" class="mx-6 mt-6 rounded-xl border border-slate-200 bg-white p-4">
            <label for="billing-account" class="block font-semibold text-slate-900">Billing account</label>
            <p class="my-2 text-sm text-slate-600">Select the billing account for this work order.</p>
            <select id="billing-account" class="rounded-lg border border-slate-300 p-2" [(ngModel)]="billingChoice" [disabled]="billingSaving || billing.pending || billing.protected">
              <option *ngFor="let account of billing.accounts" [value]="account.billing_account_uuid">{{ account.label }}</option>
            </select>
            <button type="button" class="ml-3 rounded-lg bg-slate-900 px-4 py-2 text-white disabled:opacity-50" (click)="saveBilling()" [disabled]="billingSaving || billing.pending || billing.protected || billingChoice === billing.billing_account_uuid">Save billing account</button>
            <button type="button" class="ml-3 underline" (click)="loadBilling()" [disabled]="billingSaving">Refresh billing status</button>
            <p *ngIf="billing.pending" class="mt-2 text-sm">A billing update is pending or needs review. Check Roswell status before making another change.</p>
            <p *ngIf="billing.protected" class="mt-2 text-sm">This order has audited or exported financials. Correct its billing through financial review.</p>
            <p *ngIf="billingMessage" class="mt-2 text-sm" role="status">{{ billingMessage }}</p>
          </section>
          <div class="p-4 md:p-6 xl:p-8">
            <form [formGroup]="customerInfoForm">
              <mat-card class="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-none">
                <mat-card-header class="border-b border-slate-200 bg-slate-50/80 px-6 py-4">
                  <mat-card-title class="flex items-center gap-3 text-2xl font-semibold tracking-tight text-slate-900">
                    <span class="flex h-10 w-10 items-center justify-center rounded-2xl bg-cyan-500/10 text-cyan-700">
                      <i class="fas fa-truck-moving"></i>
                    </span>
                    <span>Customer Information</span>
                  </mat-card-title>
                </mat-card-header>
                <mat-card-content class="space-y-8 px-6 py-6">
                  
                  <div formArrayName="subcontactInfo">
                    <div class="mb-4 border-b border-slate-200 pb-2">
                      <h3 class="text-sm font-semibold uppercase tracking-wider text-slate-500">Contacts</h3>
                    </div>
                    <div *ngFor="let grp of subcontactsFor('customer').controls; let i = index" [formGroupName]="i" class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-3 mb-4">
                      <mat-form-field appearance="outline" class="col-span-1">
                        <mat-label>Given Name</mat-label>
                        <input matInput formControlName="contactNameGiven" readonly>
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="col-span-1">
                        <mat-label>Last Name</mat-label>
                        <input matInput formControlName="contactNameFamily" readonly>
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="col-span-1">
                        <mat-label>Phone Number</mat-label>
                        <input matInput formControlName="phoneNumber" readonly>
                      </mat-form-field>
                    </div>
                    <div class="grid grid-cols-1 mt-4">
                      <mat-form-field appearance="outline" class="col-span-full">
                        <mat-label>Customer Address</mat-label>
                        <textarea matInput [value]="customerAddressText" readonly rows="3"></textarea>
                      </mat-form-field>
                    </div>
                  </div>
                  
                  <div>
                    <div class="mb-4 border-b border-slate-200 pb-2">
                      <h3 class="text-sm font-semibold uppercase tracking-wider text-slate-500">Requirements & Notifications</h3>
                    </div>
                    <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2 lg:grid-cols-4 items-center">
                      <mat-checkbox formControlName="bolRequired">BOL Required</mat-checkbox>
                      <mat-checkbox formControlName="invoiceBolRequired">Invoice BOL Required</mat-checkbox>
                      <mat-checkbox formControlName="rateQuoteRequired">Rate Quote Required</mat-checkbox>
                      <mat-checkbox formControlName="invoicePoRequired">Invoice PO Required</mat-checkbox>
                      
                      <mat-form-field appearance="outline" class="col-span-1 sm:col-span-2">
                        <mat-label>Invoice PO</mat-label>
                        <input matInput formControlName="invoicePo">
                      </mat-form-field>
                      
                      <mat-checkbox class="col-span-1 sm:col-span-2" formControlName="notificationAtPickup">Notification At Pickup</mat-checkbox>
                      <mat-checkbox class="col-span-1 sm:col-span-2" formControlName="notificationDelayedPickup">Notification Delayed Pickup</mat-checkbox>
                      <mat-checkbox class="col-span-1 sm:col-span-2" formControlName="notificationAtDelivery">Notification On Delivery</mat-checkbox>
                      <mat-checkbox class="col-span-1 sm:col-span-2" formControlName="notificationDelayedDelivery">Notification Delayed Delivery</mat-checkbox>
                      <mat-checkbox class="col-span-1 sm:col-span-2" formControlName="notificationAccessorialsIncured">Notification Accessorials Incurred</mat-checkbox>
                    </div>
                  </div>

                  <div>
                    <div class="mb-4 border-b border-slate-200 pb-2">
                      <h3 class="text-sm font-semibold uppercase tracking-wider text-slate-500">Forms & Services</h3>
                    </div>
                    <div class="flex flex-wrap gap-3">
                      <button mat-raised-button class="!rounded-full !bg-white !px-4 !py-2 !text-slate-800 !shadow-none ring-1 ring-slate-200" (click)="navigateTo('inservice')">Installation Service</button>
                      <button mat-raised-button class="!rounded-full !bg-white !px-4 !py-2 !text-slate-800 !shadow-none ring-1 ring-slate-200" (click)="navigateTo('checklist')">Installation Checklist</button>
                      <button mat-raised-button class="!rounded-full !bg-white !px-4 !py-2 !text-slate-800 !shadow-none ring-1 ring-slate-200" (click)="navigateTo('disclaimer')">Equipment Disclaimer</button>
                      <button mat-raised-button class="!rounded-full !bg-white !px-4 !py-2 !text-slate-800 !shadow-none ring-1 ring-slate-200" (click)="navigateTo('inagreement')">Installation Agreement</button>
                      <button mat-raised-button class="!rounded-full !bg-white !px-4 !py-2 !text-slate-800 !shadow-none ring-1 ring-slate-200" (click)="navigateTo('sitesurvey')">Site Service</button>
                    </div>
                  </div>

                </mat-card-content>
                <mat-card-actions class="flex justify-end gap-3 border-t border-slate-200 bg-slate-50/80 px-6 py-5">
                  <button mat-raised-button color="primary" class="!rounded-full !bg-slate-900 !px-5 !py-2 !text-white !shadow-none" (click)="postSiteChecks(customerInfoForm, 'Customer')">
                    <i class="fas fa-save"></i> Save
                  </button>
                </mat-card-actions>
              </mat-card>
            </form>
          </div>
        </mat-tab>

        <mat-tab label="Shipper Info">
          <div class="p-4 md:p-6 xl:p-8">
            <form [formGroup]="shipperInfoForm">
              <mat-card class="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-none">
                <mat-card-header class="border-b border-slate-200 bg-slate-50/80 px-6 py-4">
                  <mat-card-title class="flex items-center gap-3 text-2xl font-semibold tracking-tight text-slate-900">
                    <span class="flex h-10 w-10 items-center justify-center rounded-2xl bg-indigo-500/10 text-indigo-700">
                      <i class="fas fa-truck-moving"></i>
                    </span>
                    <span>Shipper Information</span>
                  </mat-card-title>
                </mat-card-header>
                <mat-card-content class="space-y-8 px-6 py-6">
                    <section>
                      <div class="mb-4 border-b border-slate-200 pb-2">
                        <h3 class="text-sm font-semibold uppercase tracking-wider text-slate-500">Contacts</h3>
                      </div>
                      <div formArrayName="subcontactInfo">
                        <div *ngFor="let grp of subcontactsFor('shipper').controls; let i = index" [formGroupName]="i" class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-3 mb-4">
                          <mat-form-field appearance="outline" class="col-span-1">
                            <mat-label>Given Name</mat-label>
                            <input matInput formControlName="contactNameGiven" readonly>
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="col-span-1">
                            <mat-label>Last Name</mat-label>
                            <input matInput formControlName="contactNameFamily" readonly>
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="col-span-1">
                            <mat-label>Phone Number</mat-label>
                            <input matInput formControlName="phoneNumber" readonly>
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2 lg:grid-cols-4 mt-6">
                        <mat-form-field appearance="outline" class="col-span-1 sm:col-span-2">
                          <mat-label>Job Site Contact Name</mat-label>
                          <input matInput formControlName="jobSiteContactName">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="col-span-1 sm:col-span-2">
                          <mat-label>Job Site Contact Phone</mat-label>
                          <input matInput formControlName="jobSiteContactPhone">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="col-span-1 sm:col-span-2">
                          <mat-label>Appointment Contact Name</mat-label>
                          <input matInput formControlName="appointmentContactName">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="col-span-1 sm:col-span-2">
                          <mat-label>Appointment Contact Phone</mat-label>
                          <input matInput formControlName="appointmentContactPhone">
                        </mat-form-field>
                      </div>
                    </section>
                    
                    <section>
                      <div class="grid grid-cols-1">
                        <mat-form-field appearance="outline" class="col-span-full">
                          <mat-label>Shipper Address</mat-label>
                          <textarea matInput [value]="shipperAddressText" readonly rows="3"></textarea>
                        </mat-form-field>
                      </div>
                    </section>

                    <section>
                      <div class="mb-4 border-b border-slate-200 pb-2">
                        <h3 class="text-sm font-semibold uppercase tracking-wider text-slate-500">Site Checks</h3>
                      </div>
                      <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2 lg:grid-cols-3 items-center">
                        <mat-form-field appearance="outline" class="col-span-1 sm:col-span-2 lg:col-span-3">
                          <mat-label>Pickup Reference #</mat-label>
                          <input matInput formControlName="pickupReferenceNumber">
                        </mat-form-field>
                        <mat-checkbox class="col-span-1" formControlName="pickupReferenceNumberRequired">Pickup Reference Required</mat-checkbox>
                        <mat-checkbox class="col-span-1" formControlName="loadingDock">Loading Dock</mat-checkbox>
                        <mat-checkbox class="col-span-1" formControlName="pickupTailgate">Pickup Tailgate</mat-checkbox>
                        <mat-checkbox class="col-span-1" formControlName="truckSpace">Truck Space</mat-checkbox>
                        <mat-checkbox class="col-span-1" formControlName="appointment">Appointment Required</mat-checkbox>
                        <mat-checkbox class="col-span-1" formControlName="callSite">Call Site</mat-checkbox>
                        <mat-checkbox class="col-span-1" formControlName="shippingBolRequired">Shipping BOL Required</mat-checkbox>
                      </div>
                    </section>

                    <section>
                      <div class="mb-4 border-b border-slate-200 pb-2">
                        <h3 class="text-sm font-semibold uppercase tracking-wider text-slate-500">Location Type</h3>
                      </div>
                      <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2 lg:grid-cols-4">
                        <mat-checkbox formControlName="residential">Residential</mat-checkbox>
                        <mat-checkbox formControlName="commercial">Commercial</mat-checkbox>
                        <mat-checkbox formControlName="jobSite">Job Site</mat-checkbox>
                        <mat-checkbox formControlName="unmannedJobSite">Unmanned Job Site</mat-checkbox>
                      </div>
                    </section>

                    <section>
                      <div class="mb-4 border-b border-slate-200 pb-2">
                        <h3 class="text-sm font-semibold uppercase tracking-wider text-slate-500">Notifications Required</h3>
                      </div>
                      <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2 lg:grid-cols-4">
                        <mat-checkbox formControlName="notificationAtPickup">At Pickup</mat-checkbox>
                        <mat-checkbox formControlName="notificationDelayedPickup">Delayed Pickup</mat-checkbox>
                        <mat-checkbox formControlName="notificationAtDelivery">At Delivery</mat-checkbox>
                        <mat-checkbox formControlName="notificationDelayedDelivery">Delayed Delivery</mat-checkbox>
                        <mat-checkbox formControlName="notificationAssessorialsIncured">Accessorials</mat-checkbox>
                      </div>
                    </section>
                </mat-card-content>
                <mat-card-actions class="flex flex-wrap justify-end gap-3 border-t border-slate-200 bg-slate-50/80 px-6 py-5">
                  <button mat-raised-button color="accent" class="!rounded-full !bg-white !px-5 !py-2 !text-slate-800 !shadow-none ring-1 ring-slate-200" (click)="openChangingShipperDialog()">
                    <i class="fas fa-exchange-alt"></i> Change Shipper
                  </button>
                  <button mat-raised-button color="primary" class="!rounded-full !bg-slate-900 !px-5 !py-2 !text-white !shadow-none" (click)="submitNewShipperInfo()">
                    <i class="fas fa-save"></i> Save New Shipper
                  </button>
                  <button mat-raised-button color="primary" class="!rounded-full !bg-slate-900 !px-5 !py-2 !text-white !shadow-none" (click)="postSiteChecks(shipperInfoForm, 'Shipper')">
                    <i class="fas fa-save"></i> Save Shipper Info
                  </button>
                </mat-card-actions>
              </mat-card>
            </form>
          </div>
        </mat-tab>

        <mat-tab label="Consignee Info">
          <div class="p-4 md:p-6 xl:p-8">
            <form [formGroup]="consigneeInfoForm">
              <mat-card class="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-none">
                <mat-card-header class="border-b border-slate-200 bg-slate-50/80 px-6 py-4">
                  <mat-card-title class="flex items-center gap-3 text-2xl font-semibold tracking-tight text-slate-900">
                    <span class="flex h-10 w-10 items-center justify-center rounded-2xl bg-violet-500/10 text-violet-700">
                      <i class="fas fa-truck-moving"></i>
                    </span>
                    <span>Consignee Information</span>
                  </mat-card-title>
                </mat-card-header>
                <mat-card-content class="space-y-8 px-6 py-6">
                    <section>
                      <div class="mb-4 border-b border-slate-200 pb-2">
                        <h3 class="text-sm font-semibold uppercase tracking-wider text-slate-500">Contacts</h3>
                      </div>
                      <div formArrayName="subcontactInfo">
                        <div *ngFor="let grp of subcontactsFor('consignee').controls; let i = index" [formGroupName]="i" class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-3 mb-4">
                          <mat-form-field appearance="outline" class="col-span-1">
                            <mat-label>Given Name</mat-label>
                            <input matInput formControlName="contactNameGiven" readonly>
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="col-span-1">
                            <mat-label>Last Name</mat-label>
                            <input matInput formControlName="contactNameFamily" readonly>
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="col-span-1">
                            <mat-label>Phone Number</mat-label>
                            <input matInput formControlName="phoneNumber" readonly>
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2 lg:grid-cols-4 mt-6">
                        <mat-form-field appearance="outline" class="col-span-1 sm:col-span-2">
                          <mat-label>Job Site Contact Name</mat-label>
                          <input matInput formControlName="jobSiteContactName">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="col-span-1 sm:col-span-2">
                          <mat-label>Job Site Contact Phone</mat-label>
                          <input matInput formControlName="jobSiteContactPhone">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="col-span-1 sm:col-span-2">
                          <mat-label>Appointment Contact Name</mat-label>
                          <input matInput formControlName="appointmentContactName">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="col-span-1 sm:col-span-2">
                          <mat-label>Appointment Contact Phone</mat-label>
                          <input matInput formControlName="appointmentContactPhone">
                        </mat-form-field>
                      </div>
                    </section>
                    
                    <section>
                      <div class="grid grid-cols-1">
                        <mat-form-field appearance="outline" class="col-span-full">
                          <mat-label>Consignee Address</mat-label>
                          <textarea matInput [value]="consigneeAddressText" readonly rows="3"></textarea>
                        </mat-form-field>
                      </div>
                    </section>

                    <section>
                      <div class="mb-4 border-b border-slate-200 pb-2">
                        <h3 class="text-sm font-semibold uppercase tracking-wider text-slate-500">Site Checks</h3>
                      </div>
                      <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2 lg:grid-cols-3 items-center">
                        <mat-form-field appearance="outline" class="col-span-1 sm:col-span-2 lg:col-span-3">
                          <mat-label>Delivery Reference Number</mat-label>
                          <input matInput formControlName="deliveryReferenceNumber">
                        </mat-form-field>
                        <mat-checkbox class="col-span-1" formControlName="deliveryReferenceNumberRequired">
                          Delivery Reference Number Required
                        </mat-checkbox>
                        <mat-checkbox class="col-span-1" formControlName="appointment">Appointment</mat-checkbox>
                        <mat-checkbox class="col-span-1" formControlName="loadingDock">Loading Dock</mat-checkbox>
                        <mat-checkbox class="col-span-1" formControlName="pickupTailgate">Pickup Tailgate</mat-checkbox>
                        <mat-checkbox class="col-span-1" formControlName="truckSpace">Truck Space</mat-checkbox>
                        <mat-checkbox class="col-span-1" formControlName="callSite">Call Site</mat-checkbox>
                      </div>
                    </section>

                    <section>
                      <div class="mb-4 border-b border-slate-200 pb-2">
                        <h3 class="text-sm font-semibold uppercase tracking-wider text-slate-500">Location Type</h3>
                      </div>
                      <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2 lg:grid-cols-3">
                        <mat-checkbox formControlName="commercial">Commercial</mat-checkbox>
                        <mat-checkbox formControlName="residential">Residential</mat-checkbox>
                        <mat-checkbox formControlName="jobSite">Job Site</mat-checkbox>
                        <mat-checkbox formControlName="unmannedJobSite">Unmanned Job Site</mat-checkbox>
                        <mat-checkbox formControlName="conventionCenter">Convention Center</mat-checkbox>
                        <mat-checkbox formControlName="popUpStore">Popup Store</mat-checkbox>
                      </div>
                    </section>

                    <section>
                      <div class="mb-4 border-b border-slate-200 pb-2">
                        <h3 class="text-sm font-semibold uppercase tracking-wider text-slate-500">Notification Requirements</h3>
                      </div>
                      <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2 lg:grid-cols-3">
                        <mat-checkbox formControlName="notificationAtPickup">Notification at Pickup</mat-checkbox>
                        <mat-checkbox formControlName="notificationDelayedPickup">Notification Delayed Pickup</mat-checkbox>
                        <mat-checkbox formControlName="notificationAtDelivery">Notification on Delivery</mat-checkbox>
                        <mat-checkbox formControlName="notificationDelayedDelivery">Notification Delayed Delivery</mat-checkbox>
                        <mat-checkbox formControlName="notificationAssessorialsIncured">Notification Accessorials Incurred</mat-checkbox>
                      </div>
                    </section>
                </mat-card-content>
                <mat-card-actions class="flex flex-wrap justify-end gap-3 border-t border-slate-200 bg-slate-50/80 px-6 py-5">
                  <button mat-raised-button color="accent" class="!rounded-full !bg-white !px-5 !py-2 !text-slate-800 !shadow-none ring-1 ring-slate-200" (click)="openChangingConsigneeDialog()">
                    <i class="fas fa-exchange-alt"></i> Change Consignee
                  </button>
                  <button mat-raised-button color="primary" class="!rounded-full !bg-slate-900 !px-5 !py-2 !text-white !shadow-none" (click)="submitNewConsigneeInfo()">
                    <i class="fas fa-save"></i> Save New Consignee
                  </button>
                  <button mat-raised-button color="primary" class="!rounded-full !bg-slate-900 !px-5 !py-2 !text-white !shadow-none" (click)="postSiteChecks(consigneeInfoForm, 'Consignee')">
                    <i class="fas fa-save"></i> Save Site Check Edits
                  </button>
                </mat-card-actions>
              </mat-card>
            </form>
          </div>
        </mat-tab>

        <mat-tab label="Carrier Info">
          <div class="p-4 md:p-6 xl:p-8">
            <form [formGroup]="carrierInfoForm">
              <mat-card class="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-none">
                <mat-card-header class="border-b border-slate-200 bg-slate-50/80 px-6 py-4">
                  <mat-card-title class="flex items-center gap-3 text-2xl font-semibold tracking-tight text-slate-900">
                    <span class="flex h-10 w-10 items-center justify-center rounded-2xl bg-emerald-500/10 text-emerald-700">
                      <i class="fas fa-shipping-fast"></i>
                    </span>
                    <span>Carrier Information</span>
                  </mat-card-title>
                </mat-card-header>
                <mat-card-content class="space-y-8 px-6 py-6">
                  <div formArrayName="subcontactInfo">
                    <div class="mb-4 border-b border-slate-200 pb-2">
                      <h3 class="text-sm font-semibold uppercase tracking-wider text-slate-500">Contacts</h3>
                    </div>
                    <div *ngFor="let grp of subcontactsFor('carrier').controls; let i = index" [formGroupName]="i" class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-3 mb-4">
                      <mat-form-field appearance="outline" class="col-span-1">
                        <mat-label>Given Name</mat-label>
                        <input matInput formControlName="contactNameGiven" readonly>
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="col-span-1">
                        <mat-label>Last Name</mat-label>
                        <input matInput formControlName="contactNameFamily" readonly>
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="col-span-1">
                        <mat-label>Phone Number</mat-label>
                        <input matInput formControlName="phoneNumber" readonly>
                      </mat-form-field>
                    </div>
                  </div>
                  <div>
                    <div class="mb-4 border-b border-slate-200 pb-2">
                      <h3 class="text-sm font-semibold uppercase tracking-wider text-slate-500">Organization Info</h3>
                    </div>
                    <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2">
                      <mat-form-field appearance="outline" class="col-span-1">
                        <mat-label>Organization</mat-label>
                        <input matInput formControlName="organization">
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="col-span-1">
                        <mat-label>Name</mat-label>
                        <input matInput formControlName="name">
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="col-span-1 sm:col-span-2">
                        <mat-label>Address</mat-label>
                        <textarea matInput formControlName="streetAddress" rows="2"></textarea>
                      </mat-form-field>
                    </div>
                  </div>
                </mat-card-content>
                <mat-card-actions class="flex flex-wrap justify-end gap-3 border-t border-slate-200 bg-slate-50/80 px-6 py-5">
                  <button mat-raised-button color="primary" class="!rounded-full !bg-slate-900 !px-5 !py-2 !text-white !shadow-none" (click)="submitNewCarrierInfo()">
                    <i class="fas fa-save"></i> Save
                  </button>
                  <button mat-raised-button color="accent" class="!rounded-full !bg-white !px-5 !py-2 !text-slate-800 !shadow-none ring-1 ring-slate-200" (click)="openChangingCarrierDialog()">
                    <i class="fas fa-exchange-alt"></i> Change Carrier
                  </button>
                </mat-card-actions>
              </mat-card>
            </form>
          </div>
        </mat-tab>

        <mat-tab label="Operation Info">
          <div class="space-y-6 bg-slate-50/60 p-4 md:p-6 xl:p-8">
            <section class="overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm">
              <div class="flex flex-col gap-3 border-b border-slate-200 bg-white px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
                <div class="flex items-center gap-3">
                  <span class="flex h-10 w-10 items-center justify-center rounded-lg bg-orange-50 text-orange-700 ring-1 ring-orange-100">
                    <i class="fas fa-cogs"></i>
                  </span>
                  <div>
                    <h3 class="m-0 text-lg font-semibold tracking-tight text-slate-950">Operation Information</h3>
                    <p class="m-0 text-sm text-slate-500">Rating, access, delay, and job-site controls.</p>
                  </div>
                </div>
                <button mat-raised-button color="primary" type="button" class="!rounded-lg !bg-slate-950 !px-4 !py-2 !text-white !shadow-none" (click)="submitOperationInfo()">
                  <i class="fas fa-save mr-2"></i> Save Operation Info
                </button>
              </div>

              <form [formGroup]="operationInfoForm" class="px-5 py-5">
                <div class="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
                  <div *ngFor="let flag of operationFlagOptions" class="flex min-h-[3rem] items-center rounded-lg border border-slate-200 bg-slate-50/70 px-3 py-2">
                    <mat-checkbox [formControlName]="flag.controlName">{{ flag.label }}</mat-checkbox>
                  </div>
                </div>

                <mat-form-field appearance="outline" class="mt-5 w-full">
                  <mat-label>Operations Notation</mat-label>
                  <textarea matInput formControlName="operationsNotation" rows="4"></textarea>
                </mat-form-field>
              </form>
            </section>

          </div>
        </mat-tab>

        <mat-tab label="White Glove" *ngIf="showWhiteGloveTab">
          <div class="bg-slate-50/60 p-4 md:p-6 xl:p-8">
            <section class="overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm">
              <div class="border-b border-slate-200 bg-white px-5 py-5">
                <div class="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
                  <div class="flex items-start gap-3">
                    <span class="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-sky-50 text-sky-700 ring-1 ring-sky-100">
                      <i class="fas fa-hand-holding-heart"></i>
                    </span>
                    <div>
                      <h3 class="m-0 text-xl font-semibold tracking-tight text-slate-950">White Glove</h3>
                      <p class="m-0 mt-1 text-sm text-slate-500">Special handling, onsite service, and premium delivery coordination.</p>
                    </div>
                  </div>
                </div>
              </div>

              <ng-container *ngIf="currentLabourReview as review; else noWhiteGloveReviews">
                <div class="px-5 py-5">
                  <article class="rounded-lg border border-slate-200 bg-white shadow-sm">
                    <div class="flex flex-col gap-3 border-b border-slate-200 px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
                      <div>
                        <div class="flex flex-wrap items-center gap-2">
                          <span class="rounded-full border px-3 py-1 text-xs font-bold uppercase tracking-wide" [ngClass]="labourReviewStatusClass(review)">
                            {{ formatLabourStatus(review.status) }}
                          </span>
                          <span class="text-xs font-semibold uppercase tracking-wide text-slate-400">
                            Updated {{ formatLabourTimestamp(review.updated || review.requested_at || review.created) }}
                          </span>
                        </div>
                        <h4 class="m-0 mt-2 text-base font-semibold text-slate-950">{{ labourReviewTitle(review) }}</h4>
                      </div>

                      <div class="flex flex-col gap-2 sm:flex-row sm:items-center">
                        <button
                          *ngIf="canActOnLabourReview(review)"
                          mat-raised-button
                          color="primary"
                          type="button"
                          class="!rounded-lg !bg-emerald-700 !px-4 !py-2 !text-white !shadow-none"
                          (click)="approveLabourReviewAsRequested(review, 0)"
                          [disabled]="isLabourReviewApprovalBusy(review)">
                          <i class="fas fa-check mr-2"></i> Approve Requested
                        </button>
                        <button
                          *ngIf="canActOnLabourReview(review)"
                          mat-stroked-button
                          color="warn"
                          type="button"
                          class="!rounded-lg !px-4"
                          (click)="submitLabourReviewDecision(review, 0, 'denied')"
                          [disabled]="isLabourReviewApprovalBusy(review)">
                          Deny
                        </button>
                      </div>
                    </div>

                    <div class="grid grid-cols-1 gap-4 px-5 py-5 lg:grid-cols-2 xl:grid-cols-4">
                      <section class="rounded-lg border border-slate-200 bg-slate-50 p-4">
                        <h5 class="m-0 text-sm font-semibold text-slate-950">Estimated</h5>
                        <p class="m-0 mt-1 text-xs font-semibold uppercase tracking-wide text-slate-400">Planned labor</p>
                        <dl class="mt-4 grid grid-cols-2 gap-3 text-sm">
                          <div><dt class="text-slate-500">Crew</dt><dd class="m-0 font-semibold text-slate-950">{{ formatLabourWholeNumber(review.estimated_people) }}</dd></div>
                          <div><dt class="text-slate-500">Total</dt><dd class="m-0 font-semibold text-slate-950">{{ formatLabourMinutes(review.estimated_total_minutes) }}</dd></div>
                          <div><dt class="text-slate-500">Install</dt><dd class="m-0 font-semibold text-slate-950">{{ formatLabourMinutes(review.estimated_install_minutes) }}</dd></div>
                          <div><dt class="text-slate-500">Handling</dt><dd class="m-0 font-semibold text-slate-950">{{ formatLabourMinutes(review.estimated_handling_minutes) }}</dd></div>
                        </dl>
                      </section>

                      <section class="rounded-lg border border-amber-200 bg-amber-50 p-4">
                        <h5 class="m-0 text-sm font-semibold text-amber-900">Requested</h5>
                        <p class="m-0 mt-1 text-xs font-semibold uppercase tracking-wide text-amber-700">Carrier or technician request</p>
                        <dl class="mt-4 grid grid-cols-2 gap-3 text-sm">
                          <div><dt class="text-amber-800/80">Crew</dt><dd class="m-0 font-semibold text-slate-950">{{ formatLabourWholeNumber(review.requested_people) }}</dd></div>
                          <div><dt class="text-amber-800/80">Total</dt><dd class="m-0 font-semibold text-slate-950">{{ formatLabourMinutes(review.requested_total_minutes) }}</dd></div>
                          <div><dt class="text-amber-800/80">Install</dt><dd class="m-0 font-semibold text-slate-950">{{ formatLabourMinutes(review.requested_install_minutes) }}</dd></div>
                          <div><dt class="text-amber-800/80">Handling</dt><dd class="m-0 font-semibold text-slate-950">{{ formatLabourMinutes(review.requested_handling_minutes) }}</dd></div>
                          <div><dt class="text-amber-800/80">Tech drive</dt><dd class="m-0 font-semibold text-slate-950">{{ formatTechnicianDriveHours(review.requested_technician_drive_hours) }}</dd></div>
                          <div><dt class="text-amber-800/80">Hotel</dt><dd class="m-0 font-semibold text-slate-950">{{ formatHotelNights(review.requested_technician_hotel_nights) }}</dd></div>
                        </dl>
                      </section>

                      <section class="rounded-lg border border-emerald-200 bg-emerald-50 p-4">
                        <h5 class="m-0 text-sm font-semibold text-emerald-900">Approval</h5>
                        <p class="m-0 mt-1 text-xs font-semibold uppercase tracking-wide text-emerald-700">Operations decision</p>
                        <dl class="mt-4 grid grid-cols-2 gap-3 text-sm">
                          <div><dt class="text-emerald-800/80">Crew</dt><dd class="m-0 font-semibold text-slate-950">{{ formatLabourWholeNumber(review.approved_people) }}</dd></div>
                          <div><dt class="text-emerald-800/80">Total</dt><dd class="m-0 font-semibold text-slate-950">{{ formatLabourMinutes(review.approved_total_minutes) }}</dd></div>
                          <div><dt class="text-emerald-800/80">Install</dt><dd class="m-0 font-semibold text-slate-950">{{ formatLabourMinutes(review.approved_install_minutes) }}</dd></div>
                          <div><dt class="text-emerald-800/80">Handling</dt><dd class="m-0 font-semibold text-slate-950">{{ formatLabourMinutes(review.approved_handling_minutes) }}</dd></div>
                          <div><dt class="text-emerald-800/80">Rerate</dt><dd class="m-0 font-semibold text-slate-950">{{ labourRerateStatus(review) }}</dd></div>
                        </dl>
                      </section>

                      <section class="rounded-lg border border-slate-200 bg-slate-50 p-4">
                        <div class="flex flex-wrap items-center justify-between gap-2">
                          <h5 class="m-0 text-sm font-semibold text-slate-950">Actual</h5>
                          <span class="rounded-full border px-2.5 py-1 text-xs font-bold" [ngClass]="labourActualStatusClass(review)">
                            {{ labourActualStatus(review) }}
                          </span>
                        </div>
                        <p class="m-0 mt-1 text-xs font-semibold uppercase tracking-wide text-slate-400">Recorded onsite time</p>
                        <dl class="mt-4 grid grid-cols-2 gap-3 text-sm">
                          <div><dt class="text-slate-500">In</dt><dd class="m-0 font-semibold text-slate-950">{{ formatLabourTimestamp(review.actual_started_at) }}</dd></div>
                          <div><dt class="text-slate-500">Out</dt><dd class="m-0 font-semibold text-slate-950">{{ formatLabourTimestamp(review.actual_completed_at) }}</dd></div>
                          <div><dt class="text-slate-500">Actual</dt><dd class="m-0 font-semibold text-slate-950">{{ formatLabourMinutes(labourActualMinutes(review)) }}</dd></div>
                          <div><dt class="text-slate-500">Allowed</dt><dd class="m-0 font-semibold text-slate-950">{{ formatLabourMinutes(labourAllowedMinutes(review)) }}</dd></div>
                        </dl>
                      </section>
                    </div>

                    <section
                      *ngIf="labourRerateStatus(review) !== 'Not requested'"
                      class="border-t px-5 py-5"
                      [ngClass]="labourRerateStatus(review) === 'Completed' ? 'border-emerald-200 bg-emerald-50/70' : 'border-amber-200 bg-amber-50/70'">
                      <div class="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
                        <div class="flex items-start gap-3">
                          <span
                            class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg"
                            [ngClass]="labourRerateStatus(review) === 'Completed' ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'">
                            <i class="fas" [ngClass]="labourRerateStatus(review) === 'Completed' ? 'fa-check-circle' : 'fa-clock'"></i>
                          </span>
                          <div>
                            <div class="flex flex-wrap items-center gap-2">
                              <h5 class="m-0 text-sm font-semibold text-slate-950">Financial application</h5>
                              <span
                                class="rounded-full border px-2.5 py-1 text-xs font-bold uppercase tracking-wide"
                                [ngClass]="labourRerateStatus(review) === 'Completed' ? 'border-emerald-200 bg-white text-emerald-700' : 'border-amber-200 bg-white text-amber-700'">
                                {{ labourRerateStatus(review) === 'Completed' ? 'Applied to Financials' : labourRerateStatus(review) }}
                              </span>
                            </div>
                            <p class="m-0 mt-1 text-sm text-slate-600">
                              {{ labourRerateStatus(review) === 'Completed'
                                ? 'The approved labor quantities were used to recalculate the matching financial line items.'
                                : 'The approval is saved, but the matching financial line items have not been updated yet.' }}
                            </p>
                          </div>
                        </div>

                        <p *ngIf="review.rerate_completed_at" class="m-0 text-xs font-semibold uppercase tracking-wide text-emerald-700">
                          Applied {{ formatLabourTimestamp(review.rerate_completed_at) }}
                        </p>
                      </div>

                      <dl class="mt-4 grid grid-cols-1 gap-3 text-sm sm:grid-cols-3">
                        <div class="rounded-lg border border-white/80 bg-white/80 p-3">
                          <dt class="text-xs font-semibold uppercase tracking-wide text-slate-500">Installation</dt>
                          <dd class="m-0 mt-1 font-semibold text-slate-950">
                            {{ formatLabourMinutes(review.estimated_install_minutes) }}
                            <i class="fas fa-arrow-right mx-2 text-slate-400"></i>
                            {{ formatLabourMinutes(review.approved_install_minutes) }}
                          </dd>
                        </div>
                        <div class="rounded-lg border border-white/80 bg-white/80 p-3">
                          <dt class="text-xs font-semibold uppercase tracking-wide text-slate-500">Handling</dt>
                          <dd class="m-0 mt-1 font-semibold text-slate-950">
                            {{ formatLabourMinutes(review.estimated_handling_minutes) }}
                            <i class="fas fa-arrow-right mx-2 text-slate-400"></i>
                            {{ formatLabourMinutes(review.approved_handling_minutes) }}
                          </dd>
                        </div>
                        <div class="rounded-lg border border-white/80 bg-white/80 p-3">
                          <dt class="text-xs font-semibold uppercase tracking-wide text-slate-500">Crew</dt>
                          <dd class="m-0 mt-1 font-semibold text-slate-950">
                            {{ formatLabourWholeNumber(review.estimated_people) }}
                            <i class="fas fa-arrow-right mx-2 text-slate-400"></i>
                            {{ formatLabourWholeNumber(review.approved_people) }}
                          </dd>
                        </div>
                      </dl>
                    </section>

                    <div class="grid grid-cols-1 gap-4 border-t border-slate-200 px-5 py-4 lg:grid-cols-2">
                      <div class="rounded-lg border border-slate-200 bg-white p-4">
                        <h5 class="m-0 text-sm font-semibold text-slate-950">Request Notes</h5>
                        <p class="m-0 mt-3 whitespace-pre-wrap text-sm leading-6 text-slate-700">
                          {{ review.requested_notes || 'No request notes were provided.' }}
                        </p>
                      </div>

                      <div class="rounded-lg border border-slate-200 bg-white p-4">
                        <h5 class="m-0 text-sm font-semibold text-slate-950">Approval Notes</h5>
                        <p class="m-0 mt-3 whitespace-pre-wrap text-sm leading-6 text-slate-700">
                          {{ review.approved_notes || 'No approval notes yet.' }}
                        </p>
                        <p *ngIf="review.approved_at" class="m-0 mt-3 text-xs font-semibold uppercase tracking-wide text-slate-400">
                          Approved {{ formatLabourTimestamp(review.approved_at) }}
                        </p>
                      </div>
                    </div>

                    <details *ngIf="canActOnLabourReview(review)" class="border-t border-amber-300 bg-amber-50/80 px-5 py-4">
                      <summary class="wg-adjust-attention flex cursor-pointer list-none items-center justify-between gap-3 overflow-hidden rounded-lg border border-amber-300 bg-white px-4 py-3 text-sm font-semibold text-amber-950 shadow-sm transition hover:border-amber-400 hover:bg-amber-50">
                        <span class="flex min-w-0 flex-1 items-center gap-3">
                          <span class="flex h-9 w-9 items-center justify-center rounded-lg bg-amber-100 text-amber-800">
                            <i class="fas fa-sliders-h"></i>
                          </span>
                          <span>
                            <span class="block text-sm font-semibold text-slate-950">Adjust approval values</span>
                            <span class="block text-xs font-medium text-slate-500">Override crew or minutes before approving.</span>
                          </span>
                        </span>
                        <span class="flex items-center gap-2">
                          <span class="wg-adjust-arrows flex items-center gap-1 text-amber-700" aria-hidden="true">
                            <i class="fas fa-chevron-right"></i>
                            <i class="fas fa-chevron-right"></i>
                            <i class="fas fa-chevron-right"></i>
                          </span>
                          <span class="rounded-full bg-amber-100 px-3 py-1 text-xs font-bold uppercase tracking-wide text-amber-800 ring-1 ring-amber-200">
                            Optional
                          </span>
                        </span>
                      </summary>

                      <form [formGroup]="labourReviewFormAt(0)" class="mt-4">
                        <div class="mb-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                          <p class="m-0 text-sm text-slate-600">Adjusted approval total: {{ labourReviewApprovalTotal(0) }}</p>
                          <span class="rounded-full border border-sky-200 bg-sky-50 px-3 py-1 text-xs font-bold uppercase tracking-wide text-sky-700">
                            Financials update automatically
                          </span>
                        </div>

                        <div class="grid grid-cols-1 gap-4 md:grid-cols-3">
                          <mat-form-field appearance="outline">
                            <mat-label>Approved Install Minutes</mat-label>
                            <input matInput type="number" min="0" step="1" formControlName="approvedInstallMinutes">
                          </mat-form-field>

                          <mat-form-field appearance="outline">
                            <mat-label>Approved Handling Minutes</mat-label>
                            <input matInput type="number" min="0" step="1" formControlName="approvedHandlingMinutes">
                          </mat-form-field>

                          <mat-form-field appearance="outline">
                            <mat-label>Approved Crew</mat-label>
                            <input matInput type="number" min="0" step="1" formControlName="approvedPeople" (blur)="coerceLabourReviewPeople(0)">
                          </mat-form-field>
                        </div>

                        <mat-form-field appearance="outline" class="w-full">
                          <mat-label>Approval Notes</mat-label>
                          <textarea matInput formControlName="approvedNotes" rows="3"></textarea>
                        </mat-form-field>

                        <div class="flex flex-wrap justify-end gap-3">
                          <button mat-button type="button" class="!rounded-lg !px-4" (click)="resetLabourReviewForm(0)" [disabled]="isLabourReviewApprovalBusy(review)">
                            Reset
                          </button>
                          <button mat-raised-button color="primary" type="button" class="!rounded-lg !bg-slate-950 !px-4 !text-white !shadow-none" (click)="submitLabourReviewDecision(review, 0, 'approved')" [disabled]="labourReviewFormAt(0).invalid || isLabourReviewApprovalBusy(review)">
                            Approve Adjusted
                          </button>
                        </div>
                      </form>
                    </details>
                  </article>
                </div>
              </ng-container>

              <ng-template #noWhiteGloveReviews>
                <div class="px-5 py-12 text-center">
                  <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-lg bg-sky-50 text-sky-700 ring-1 ring-sky-100">
                    <i class="fas fa-hand-holding-heart"></i>
                  </div>
                  <h4 class="m-0 mt-4 text-base font-semibold text-slate-950">No labor review record yet</h4>
                  <p class="m-0 mt-1 text-sm text-slate-500">Estimated, requested, and approved labor will appear here when the API returns a white glove labor row.</p>
                </div>
              </ng-template>
            </section>
          </div>
        </mat-tab>

        <mat-tab label="Technician" *ngIf="generalInfoForm.get('customer_name')?.value.includes('TECHNOGYM')">
          <div class="p-4 md:p-6 xl:p-8">
            <form [formGroup]="technicianInfoForm">
              <mat-card class="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-none">
                <mat-card-header class="border-b border-slate-200 bg-slate-50/80 px-6 py-4">
                  <mat-card-title class="text-2xl font-semibold tracking-tight text-slate-900">
                    Technician Information
                  </mat-card-title>
                </mat-card-header>
                <mat-card-content class="px-6 py-6">
                  <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-3">
                    <mat-form-field appearance="outline" class="col-span-1">
                      <mat-label>First Name</mat-label>
                      <input matInput formControlName="contact_name_given">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="col-span-1">
                      <mat-label>Middle Name</mat-label>
                      <input matInput formControlName="contact_name_middle">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="col-span-1">
                      <mat-label>Last Name</mat-label>
                      <input matInput formControlName="contact_name_family">
                    </mat-form-field>
                    <mat-form-field class="col-span-1 sm:col-span-3">
                      <mat-label>Email Address</mat-label>
                      <input matInput formControlName="contact_email">
                    </mat-form-field>
                  </div>
                </mat-card-content>
              </mat-card>
            </form>
          </div>
        </mat-tab>

        <mat-tab label="Administration">
          <div class="space-y-6 p-4 md:p-6 xl:p-8">
            <form [formGroup]="administrationInfoForm">
              <mat-card class="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-none">
                <mat-card-header class="border-b border-slate-200 bg-slate-50/80 px-6 py-4">
                  <mat-card-title class="flex items-center gap-3 text-2xl font-semibold tracking-tight text-slate-900">
                    <span class="flex h-10 w-10 items-center justify-center rounded-2xl bg-rose-500/10 text-rose-700">
                      <i class="fas fa-user-cog"></i>
                    </span>
                    <span>Administration Information</span>
                  </mat-card-title>
                </mat-card-header>
                <mat-card-content class="px-6 py-6">
                  <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2 lg:grid-cols-4 items-center mb-6">
                    <mat-checkbox formControlName="poAudited">PO Audited</mat-checkbox>
                    <mat-checkbox formControlName="podAudited">POD Audited</mat-checkbox>
                    <mat-checkbox formControlName="confirmCharges">Confirm Charges</mat-checkbox>
                    <mat-checkbox formControlName="carrierInvoiced">Carrier Invoiced</mat-checkbox>
                    <mat-checkbox formControlName="freightCostApproved">Freight Cost Approved</mat-checkbox>
                    <mat-checkbox formControlName="freightCostException">Freight Cost Exception</mat-checkbox>
                    <mat-checkbox formControlName="readyInvoice">Ready Invoice</mat-checkbox>
                    <mat-checkbox formControlName="damageClaim">Damage Claim</mat-checkbox>
                    <mat-checkbox formControlName="intentClaim">Intent Claim</mat-checkbox>
                    <mat-checkbox formControlName="claimReview">Claim Review</mat-checkbox>
                    <mat-checkbox formControlName="invoiceThanks">Invoice Thanks</mat-checkbox>
                    <mat-checkbox formControlName="invoiceDue">Invoice Due</mat-checkbox>
                    <mat-checkbox formControlName="invoiceCorrect">Invoice Correct</mat-checkbox>
                    <mat-checkbox formControlName="invoiceLate">Invoice Late</mat-checkbox>
                    <mat-checkbox formControlName="carrierInvoiceExported">Carrier Invoice Exported</mat-checkbox>
                    <mat-checkbox formControlName="customerInvoiceExported">Customer Invoice Exported</mat-checkbox>
                    <mat-checkbox formControlName="specialInvoice">Special Invoice</mat-checkbox>
                  </div>
                  
                  <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2">
                    <mat-form-field appearance="outline" class="col-span-1">
                      <mat-label>Customer Invoice Date</mat-label>
                      <input matInput type="date" formControlName="customerInvoiceDate">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="col-span-1">
                      <mat-label>Versapay Payment Reference</mat-label>
                      <input matInput formControlName="versapayPaymentReference">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="col-span-1 sm:col-span-2">
                      <mat-label>Freight Cost Notation</mat-label>
                      <textarea matInput formControlName="freightCostNotation" rows="2"></textarea>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="col-span-1 sm:col-span-2">
                      <mat-label>Administration Notation</mat-label>
                      <textarea matInput formControlName="administrationNotation" rows="2"></textarea>
                    </mat-form-field>
                  </div>
                </mat-card-content>
                <mat-card-actions class="flex justify-end gap-3 border-t border-slate-200 bg-slate-50/80 px-6 py-5">
                  <button mat-raised-button color="primary" class="!rounded-full !bg-slate-900 !px-5 !py-2 !text-white !shadow-none" (click)="submitAdministrationInfo()">
                    <i class="fas fa-save"></i> Save
                  </button>
                </mat-card-actions>
              </mat-card>
            </form>

            <form [formGroup]="claimInfoForm">
              <mat-card class="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-none">
                <mat-card-header class="border-b border-slate-200 bg-slate-50/80 px-6 py-4">
                  <mat-card-title class="flex items-center gap-3 text-2xl font-semibold tracking-tight text-slate-900">
                    <span class="flex h-10 w-10 items-center justify-center rounded-2xl bg-amber-500/10 text-amber-700">
                      <i class="fas fa-file-invoice-dollar"></i>
                    </span>
                    <span>Claim Information</span>
                  </mat-card-title>
                </mat-card-header>
                <mat-card-content class="px-6 py-6">
                  <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-3">
                    <mat-form-field appearance="outline" class="col-span-1">
                      <mat-label>Customer Name</mat-label>
                      <input matInput formControlName="customerName">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="col-span-1">
                      <mat-label>FBI Reference</mat-label>
                      <input matInput formControlName="fbiReference">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="col-span-1">
                      <mat-label>Date Notified</mat-label>
                      <input matInput [matDatepicker]="dateNotifiedPicker" formControlName="dateNotified">
                      <mat-datepicker-toggle matSuffix [for]="dateNotifiedPicker"></mat-datepicker-toggle>
                      <mat-datepicker #dateNotifiedPicker></mat-datepicker>
                    </mat-form-field>
                  </div>
                </mat-card-content>
                <mat-card-actions class="flex justify-end gap-3 border-t border-slate-200 bg-slate-50/80 px-6 py-5">
                  <button mat-raised-button color="primary" class="!rounded-full !bg-slate-900 !px-5 !py-2 !text-white !shadow-none" (click)="submitClaimInfo()">
                    <i class="fas fa-save"></i> Save
                  </button>
                </mat-card-actions>
              </mat-card>
            </form>

            <form [formGroup]="salesInfoForm">
              <mat-card class="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-none">
                <mat-card-header class="border-b border-slate-200 bg-slate-50/80 px-6 py-4">
                  <mat-card-title class="flex items-center gap-3 text-2xl font-semibold tracking-tight text-slate-900">
                    <span class="flex h-10 w-10 items-center justify-center rounded-2xl bg-lime-500/10 text-lime-700">
                      <i class="fas fa-chart-line"></i>
                    </span>
                    <span>Sales Information</span>
                  </mat-card-title>
                </mat-card-header>
                <mat-card-content class="px-6 py-6">
                  <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-3 mb-6 items-center">
                    <mat-checkbox formControlName="quoteRequired">Quote Required</mat-checkbox>
                    <mat-checkbox formControlName="requoteRequired">Requote Required</mat-checkbox>
                    <mat-checkbox formControlName="customerRated">Customer Rated</mat-checkbox>
                  </div>
                  <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2">
                    <mat-form-field appearance="outline" class="col-span-1 sm:col-span-2">
                      <mat-label>Sales Notation</mat-label>
                      <textarea matInput formControlName="salesNotation" rows="2"></textarea>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="col-span-1 sm:col-span-2">
                      <mat-label>Management Notation</mat-label>
                      <textarea matInput formControlName="managementNotation" rows="2"></textarea>
                    </mat-form-field>
                  </div>
                </mat-card-content>
                <mat-card-actions class="flex justify-end gap-3 border-t border-slate-200 bg-slate-50/80 px-6 py-5">
                  <button mat-raised-button color="primary" class="!rounded-full !bg-slate-900 !px-5 !py-2 !text-white !shadow-none" (click)="submitSalesInfo()">
                    <i class="fas fa-save"></i> Save
                  </button>
                </mat-card-actions>
              </mat-card>
            </form>
          </div>
        </mat-tab>

        <mat-tab label="Documents">
          <ng-template mat-tab-label>
            <span>Documents</span>
            <span class="ml-1.5 inline-flex h-4 min-w-[1rem] items-center justify-center rounded-full bg-indigo-100 px-1 text-[9px] font-extrabold leading-none text-indigo-700">
              {{ documentsTable.data.length }}
            </span>
          </ng-template>
          <div class="space-y-4 p-4 md:p-6 xl:p-8">
            <input
              #documentFileInput
              type="file"
              class="hidden"
              (change)="handleDocumentFileSelection($event)"
            />

            <section class="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-none">
              <header class="flex flex-col gap-3 border-b border-slate-200 bg-slate-50/80 px-5 py-4 sm:flex-row sm:items-center sm:justify-between md:px-6">
                <div class="flex min-w-0 items-center gap-3">
                  <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-sky-500/10 text-sky-700">
                    <i class="fas fa-folder-open"></i>
                  </span>
                  <div class="min-w-0">
                    <div class="flex items-center gap-3">
                      <h2 class="m-0 text-xl font-semibold leading-none tracking-tight text-slate-900">Documents</h2>
                      <span class="inline-flex h-5 min-w-[1.25rem] shrink-0 items-center justify-center rounded-md bg-slate-100 px-1.5 text-[10px] font-bold leading-none text-slate-500 ring-1 ring-inset ring-slate-200">
                        {{ documentsTable.data.length }}
                      </span>
                    </div>
                  </div>
                </div>

                <button
                  type="button"
                  class="inline-flex items-center justify-center gap-2 rounded-full bg-slate-900 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-slate-700"
                  (click)="documentFileInput.click()"
                >
                  <i class="fas fa-plus"></i>
                  Add document
                </button>
              </header>

              <div class="p-4 md:px-5">
                <button
                  type="button"
                  class="document-drop-area relative flex min-h-[132px] w-full items-center gap-4 overflow-hidden rounded-[24px] border border-transparent bg-transparent px-5 py-6 text-left text-slate-900 transition md:px-7"
                  (dragover)="handleDocumentDragOver($event)"
                  (dragleave)="handleDocumentDragLeave($event)"
                  (drop)="handleDocumentDrop($event)"
                  (click)="documentFileInput.click()"
                  [ngClass]="{ 'dragging-over': isDraggingOverDocument }"
                >
                  <span class="relative z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-sky-50 text-xl text-sky-600 shadow-[0_0_26px_rgba(14,165,233,0.16)] ring-1 ring-inset ring-sky-200">
                    <i class="fas fa-cloud-upload-alt"></i>
                  </span>
                  <span class="relative z-10 min-w-0 flex-1">
                    <span class="block text-lg font-semibold tracking-tight text-slate-900">Drop a document here</span>
                    <span class="mt-1 block text-sm text-slate-500">Choose a file, then select its document type.</span>
                  </span>
                  <span class="relative z-10 hidden rounded-full border border-sky-300 bg-white px-4 py-2 text-xs font-bold text-sky-800 shadow-[0_0_22px_rgba(14,165,233,0.14)] sm:inline-flex">
                    Choose file
                  </span>
                </button>
              </div>

              <div *ngIf="documentsTable.data.length; else noDocuments" class="border-t border-slate-200">
                <div class="hidden grid-cols-[minmax(0,1.45fr)_minmax(8rem,0.65fr)_minmax(0,1fr)_auto] gap-4 bg-slate-50/70 px-5 py-2 text-[11px] font-bold uppercase tracking-[0.12em] text-slate-500 md:grid">
                  <span>File</span>
                  <span>Document type</span>
                  <span>Description</span>
                  <span class="text-right">Actions</span>
                </div>

                <div
                  *ngFor="let document of documentsTable.data"
                  class="document-list-row grid gap-3 border-t border-slate-100 px-4 py-3 first:border-t-0 md:grid-cols-[minmax(0,1.45fr)_minmax(8rem,0.65fr)_minmax(0,1fr)_auto] md:items-center md:gap-4 md:px-5"
                >
                  <div class="flex min-w-0 items-center gap-3">
                    <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-sky-500/10 text-sky-700">
                      <i [ngClass]="getDocumentIconClass(document.file_format)"></i>
                    </span>
                    <div class="min-w-0">
                      <p class="truncate text-sm font-semibold text-slate-900" [title]="document.file_name">{{ document.file_name }}</p>
                      <p class="mt-0.5 text-xs text-slate-500">
                        {{ (document.file_format || 'file') | uppercase }}
                        <span class="px-1 text-slate-300">&bull;</span>
                        {{ formatFileSize(document.file_size) }}
                        <ng-container *ngIf="document.created">
                          <span class="px-1 text-slate-300">&bull;</span>
                          {{ document.created | date:'MMM d, y' }}
                        </ng-container>
                      </p>
                    </div>
                  </div>

                  <div>
                    <span class="mb-1 block text-[10px] font-bold uppercase tracking-wider text-slate-400 md:hidden">Document type</span>
                    <span class="inline-flex max-w-full rounded-full bg-indigo-50 px-2.5 py-1 text-xs font-bold text-indigo-700 ring-1 ring-inset ring-indigo-200">
                      {{ getDocumentTypeLabel(document.document_type) }}
                    </span>
                  </div>

                  <div class="min-w-0">
                    <span class="mb-1 block text-[10px] font-bold uppercase tracking-wider text-slate-400 md:hidden">Description</span>
                    <p class="truncate text-sm text-slate-600" [title]="document.file_description || ''">
                      {{ document.file_description || 'No description' }}
                    </p>
                  </div>

                  <div class="flex items-center gap-2 md:justify-end">
                    <button
                      type="button"
                      class="inline-flex items-center justify-center gap-2 rounded-full border border-slate-300 bg-white px-3 py-1.5 text-xs font-bold text-slate-700 transition hover:border-slate-400 hover:bg-slate-50 disabled:cursor-wait disabled:opacity-60"
                      [disabled]="openingDocumentUuid === document.upload_document_uuid"
                      (click)="openDocument(document)"
                    >
                      <i [ngClass]="openingDocumentUuid === document.upload_document_uuid ? 'fas fa-spinner fa-spin' : 'fas fa-eye'"></i>
                      {{ openingDocumentUuid === document.upload_document_uuid ? 'Opening' : 'View' }}
                    </button>
                    <button
                      type="button"
                      class="inline-flex items-center justify-center gap-2 rounded-full bg-slate-900 px-3 py-1.5 text-xs font-bold text-white transition hover:bg-slate-700 disabled:cursor-wait disabled:opacity-60"
                      [disabled]="downloadingDocumentUuid === document.upload_document_uuid"
                      (click)="downloadDocument(document)"
                    >
                      <i [ngClass]="downloadingDocumentUuid === document.upload_document_uuid ? 'fas fa-spinner fa-spin' : 'fas fa-download'"></i>
                      {{ downloadingDocumentUuid === document.upload_document_uuid ? 'Saving' : 'Download' }}
                    </button>
                  </div>
                </div>
              </div>

              <ng-template #noDocuments>
                <div class="flex items-center gap-3 border-t border-slate-200 px-5 py-5 text-sm text-slate-500">
                  <i class="far fa-folder-open text-lg text-slate-400"></i>
                  No documents uploaded yet
                </div>
              </ng-template>
            </section>

            <div class="supporting-assets-grid grid gap-6 lg:grid-cols-2">
              <section class="supporting-assets-card supporting-assets-card--images overflow-hidden rounded-[24px] border border-violet-200 bg-white">
                <header class="flex items-center justify-between border-b border-violet-100 bg-violet-50/70 px-5 py-3.5">
                  <div class="flex items-center gap-3">
                    <span class="flex h-10 w-10 items-center justify-center rounded-xl bg-white text-violet-700 shadow-sm ring-1 ring-violet-200">
                      <i class="fas fa-images"></i>
                    </span>
                    <h3 class="text-base font-semibold text-slate-900">Product Images</h3>
                  </div>
                  <span class="rounded-full bg-white px-2.5 py-0.5 text-xs font-bold text-slate-600 ring-1 ring-slate-200">
                    {{ productImagesTable.data.length }}
                  </span>
                </header>

                <div *ngIf="productImagesTable.data.length; else noProductImages">
                  <div *ngFor="let image of productImagesTable.data; let i = index" class="flex items-center gap-3 border-t border-slate-100 px-5 py-3 first:border-t-0">
                    <img [src]="image.thumbnail" class="h-11 w-11 shrink-0 rounded-xl border border-slate-200 object-cover" alt="" />
                    <div class="min-w-0 flex-1">
                      <p class="truncate text-sm font-semibold text-slate-900">{{ image.image_name }}</p>
                      <p class="text-xs text-slate-500">{{ image.product_code || 'No product code' }}</p>
                    </div>
                    <div class="flex items-center gap-1">
                      <button type="button" class="rounded-full px-2.5 py-1.5 text-xs font-bold text-sky-700 hover:bg-sky-50" (click)="viewProductImage(image, i)">
                        View
                      </button>
                      <button type="button" class="rounded-full px-2.5 py-1.5 text-xs font-bold text-rose-700 hover:bg-rose-50" (click)="deleteProductImage(image)">
                        Delete
                      </button>
                    </div>
                  </div>
                </div>

                <ng-template #noProductImages>
                  <div class="flex min-h-[88px] items-center gap-3 px-5 py-5 text-sm text-slate-500">
                    <i class="far fa-image text-lg text-slate-400"></i>
                    No product images
                  </div>
                </ng-template>
              </section>

              <section class="supporting-assets-card supporting-assets-card--signatures overflow-hidden rounded-[24px] border border-emerald-200 bg-white">
                <header class="flex items-center justify-between border-b border-emerald-100 bg-emerald-50/70 px-5 py-3.5">
                  <div class="flex items-center gap-3">
                    <span class="flex h-10 w-10 items-center justify-center rounded-xl bg-white text-emerald-700 shadow-sm ring-1 ring-emerald-200">
                      <i class="fas fa-signature"></i>
                    </span>
                    <h3 class="text-base font-semibold text-slate-900">Signatures</h3>
                  </div>
                  <span class="rounded-full bg-white px-2.5 py-0.5 text-xs font-bold text-slate-600 ring-1 ring-slate-200">
                    {{ signatures.length }}
                  </span>
                </header>

                <div *ngIf="signatures.length; else noSignatures">
                  <div *ngFor="let signature of signatures" class="flex items-center gap-3 border-t border-slate-100 px-5 py-3 first:border-t-0">
                    <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-emerald-50 text-emerald-700">
                      <i class="fas fa-pen-nib"></i>
                    </span>
                    <div class="min-w-0 flex-1">
                      <p class="truncate text-sm font-semibold text-slate-900">{{ signature.signatory || 'Unknown signer' }}</p>
                      <p class="text-xs text-slate-500">{{ signature.date_signed | date:'MMM d, y' }}</p>
                    </div>
                    <button type="button" class="rounded-full px-3 py-1.5 text-xs font-bold text-emerald-700 hover:bg-emerald-50" (click)="viewSignature(signature)">
                      View
                    </button>
                  </div>
                </div>

                <ng-template #noSignatures>
                  <div class="flex min-h-[88px] items-center gap-3 px-5 py-5 text-sm text-slate-500">
                    <i class="fas fa-pen-nib text-lg text-slate-400"></i>
                    No signatures
                  </div>
                </ng-template>
              </section>
            </div>
          </div>
        </mat-tab>

        <mat-tab label="Financials">
          <ng-template matTabContent>
            <div class="p-4 md:p-6 xl:p-8">
              <app-new-new-financials [hideMenu]="true" [ladingUuid]="workOrderLadingUuid"></app-new-new-financials>
            </div>
          </ng-template>
        </mat-tab>

        <mat-tab label="History" *ngIf="canViewWorkOrderHistory">
          <ng-template matTabContent>
            <div class="p-4 md:p-6 xl:p-8">
              <app-work-order-history
                [ladingUuid]="workOrderLadingUuid"
                [financialsAllowed]="canViewFinancialHistory"
                [active]="activeTabLabel === 'History'"
              ></app-work-order-history>
            </div>
          </ng-template>
        </mat-tab>

        <mat-tab label="UFOs history" *ngIf="canViewUfos">
          <ng-template matTabContent>
            <div class="p-4 md:p-6 xl:p-8">
              <app-ufos-history
                [ladingUuid]="workOrderLadingUuid"
                [active]="activeTabLabel === 'UFOs history'"
              ></app-ufos-history>
            </div>
          </ng-template>
        </mat-tab>

        <mat-tab label="UFOs" *ngIf="canViewUfos">
          <ng-template matTabContent>
            <app-ufos [ladingUuid]="workOrderLadingUuid"></app-ufos>
          </ng-template>
        </mat-tab>

      </mat-tab-group>

      <button
        *ngIf="activeTabLabel === 'General Info' && !isLoading"
        type="button"
        class="wo-save-fab"
        [disabled]="generalInfoForm.pristine"
        (click)="submitGeneralInfoForm()"
      >
        <i class="fas fa-save"></i>
        <span>Save General Info</span>
      </button>
    </div>
  </div>
</app-menu>
